import React, {useEffect, useState} from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'

import {CheckmarkIcon} from '@modifi/ui'
import {GreenCycle} from './styles'
import FadeIn from '../fade-in'

const propTypes = {
  className: PropTypes.string,
}
const defaultProps = {
  className: undefined,
}

type SuccessBadgeProps = InferPropTypes<typeof propTypes, typeof defaultProps>

const SuccessBadge: React.FC<SuccessBadgeProps> = ({className}) => {
  const [visible, setVisible] = useState(false)
  useEffect(() => {
    let frame: number | undefined
    const timeout = setTimeout(() => {
      frame = requestAnimationFrame(() => {
        setVisible(true)
      })
    }, 250)
    return () => {
      frame && cancelAnimationFrame(frame)
      clearTimeout(timeout)
    }
  }, [])

  return (
    <FadeIn>
      <GreenCycle mounted={visible} className={className}>
        <CheckmarkIcon height={20} width={20} />
      </GreenCycle>
    </FadeIn>
  )
}

SuccessBadge.propTypes = propTypes
SuccessBadge.defaultProps = defaultProps

export default SuccessBadge
